import gql from 'graphql-tag';

export const queryForCommercialOperationalNotes = gql`
  query queryForCommercialOperationalNotes(
    $page: Int!
    $limit: Int!
    $query: CommercialOperationalNoteSortOrQuery!
    $sort: CommercialOperationalNoteSortOrQuery
  ) {
    queryForCommercialOperationalNotes(
      page: $page
      limit: $limit
      query: $query
      sort: $sort
    ) {
      items {
        id
        facilityName
        facilityId
        category
        aorName
        contactName
        comments
        updatedAt
        flexStart
        flexEnd
        flexType
        flexAmount
      }
      totalRecords
    }
  }
`;
